import { Component } from '@angular/core';
import { AuthenticationService } from '@assetaccountant/core';

@Component({
  selector: 'app-logout',
  template: '',
  standalone: false,
})
export class LogoutComponent {
  constructor(authService: AuthenticationService) {
    // Return to the app root, not /logout, so signing back in doesn't log out again
    authService.logOut(`${window.location.origin}/`);
  }
}
